
import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Box } from '@mui/material';
import { handlePrint } from './printUtils';

/**
 * PrintContainer
 * Wraps content that should be printable.
 * Exposes a `print()` method via ref.
 */
const PrintContainer = forwardRef(({ children, title, ...props }, ref) => {
  const contentRef = useRef(null);

  useImperativeHandle(ref, () => ({
    print: () => {
      handlePrint(contentRef.current, title);
    }
  }));

  return (
    <Box ref={contentRef} {...props}>
      {children}
    </Box>
  );
});

PrintContainer.displayName = 'PrintContainer';

export default PrintContainer;
